<script>
import {
  DeleteOutlined,
  PlusOutlined,
  LeftOutlined,
  RightOutlined,
  CloseOutlined,
} from '@ant-design/icons-vue';
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import UploadImages from '@/components/ux/upload/Upload-images.vue';
import uploadFile from '@/utils/uploadFile';
import ArticleAdsCard from '@/pages/article/cards/ArticleAdsCard.vue';
import CustomAdsCard from '@/pages/article/cards/CustomAdsCard.vue';
import SocialAdsCard from '@/pages/article/cards/SocialAdsCard.vue';
import ProductAdsCard from '@/pages/article/cards/ProductAdsCard.vue';
import constants from './constants';

const b = bem('article-ads-banner');

const {
  SOCIAL_NETWORK_TYPE,
  PRODUCT_TYPES_LIST,
  PRODUCTS_LIST,
  PRODUCT_TYPES,
  PRODUCT_PAGES,
  ARTICLE,
  PRODUCT,
  CUSTOM_ADS,
  SOCIAL_NETWORK,
} = constants;

export default {
  components: {
    LeftOutlined,
    RightOutlined,
    SocialAdsCard,
    CustomAdsCard,
    ArticleAdsCard,
    ProductAdsCard,
    DeleteOutlined,
    UploadImages,
    PlusOutlined,
    CloseOutlined,
  },
  data() {
    return {
      SOCIAL_NETWORK_TYPE,
      PRODUCT_TYPES_LIST,
      PRODUCTS_LIST,
      PRODUCT_TYPES,
      PRODUCT_PAGES,
      ARTICLE,
      PRODUCT,
      CUSTOM_ADS,
      SOCIAL_NETWORK,

      isShowEditorBanner: false,
      activeKey: CUSTOM_ADS,

      socialsNetwork: [],
      socialsNetworkImageList: [],
      selectedCollectionOnPage: null,
      selectedCollection: null,
      selectedFrame: null,
      selectedProducts: [],
      selectedProductType: null,
      selectedPageCollections: [],
      productId: null,
      selectedPage: null,
      selectedDigitizeOption: null,
      productOptions: [],
      imageFileListCustom: [],
      imageFileListProduct: [],
      editableBannerId: null,
      editableTitle: '',
      editableDescription: '',
      editableLink: '',
      editableButtonText: '',
      editableArticlesList: [],
      editableImageFileListCustom: [],
      editableImageFileListProduct: [],
    };
  },
  methods: {
    ...mapActions({
      getArticlesAction: 'blogs/getArticles',
      deleteArticleBannerActions: 'blogs/deleteArticleBanner',
      editArticleBannerOrderActions: 'blogs/editArticleBannerOrder',
      createOrEditArticleBannerActions: 'blogs/createOrEditArticleBanner',
      getProductsActions: 'products/getProducts',
      getProductCollectionsActions: 'products/getProductCollections',
      getOneProductCollectionsActions: 'products/getOneProductCollections',
      clearOneProductCollectionsActions: 'products/clearOneProductCollections',
      getAllProductCollectionsActions: 'products/getAllProductCollections',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    handleShowEditorBanner() {
      if (this.isShowEditorBanner) {
        this.setDefaultData();
        this.activeKey = CUSTOM_ADS;
      }
      this.isShowEditorBanner = !this.isShowEditorBanner;
    },
    onSubmitForm(formName) {
      this.$formkit.submit(formName);
    },
    async addToSocialNetworkList(values) {
      if (!this.socialsNetworkImageList.length) {
        return null;
      }
      let imageUrl = '';
      const { file, url } = this.socialsNetworkImageList[0];
      if (file) {
        const {
          data: {
            data: {
              url: UploadedUrl,
            },
          },
        } = await uploadFile(file, 'images-blog');
        imageUrl = UploadedUrl;
      } else {
        imageUrl = url;
      }
      this.socialsNetwork.push({
        ...values,
        imageUrl,
      });
      this.$formkit.reset('socialNetworkList');
      return null;
    },
    onDeleteSocialNetwork(index) {
      this.socialsNetwork = this.socialsNetwork.filter((_, elIndex) => (elIndex !== index));
    },
    onSubmit(value) {
      const {
        title,
        description,
        productId,
        articlesId,
        link,
        buttonText,
      } = value;
      let image = {};
      switch (this.activeKey) {
        case CUSTOM_ADS: {
          image = this.imageFileListCustom[0] || {};
          break;
        }
        case PRODUCT: {
          image = this.imageFileListProduct[0] || {};
          break;
        }
        default: {
          image = {};
          break;
        }
      }
      const values = {
        type: this.activeKey,
        title: title || '',
        description: description || '',
        productId: productId || null,
        productCollectionId: this.selectedCollection || null,
        articlesId: articlesId || [],
        forArticleId: this.currentArticle.id,
        socialsNetwork: this.socialsNetwork || [],
      };
      if ([PRODUCT, CUSTOM_ADS].includes(this.activeKey)) {
        values.link = link || '';
        values.buttonText = buttonText || '';
      }
      this.createOrEditArticleBannerActions({
        articleId: this.currentArticle.id,
        editableBannerId: this.editableBannerId,
        values,
        image,
        callback: this.handleShowEditorBanner,
      });
    },
    getOptionListFrames() {
      return (this.currentProductCollection?.products || []).reduce((acc, frame) => {
        if (frame.options && frame.options.length > 0 && !frame.isDeleted) {
          return [...acc, { value: frame.id, label: frame.displayName }];
        }
        return acc;
      }, []);
    },
    handleChangeOptions(value, type) {
      this.productId = '';
      this.productOptions = [];
      switch (type) {
        case 'productType': {
          this.clearOneProductCollectionsActions();
          this.selectedCollectionOnPage = null;
          if (value !== PRODUCT_TYPES.photoArt) {
            this.selectedProducts = this.productList.reduce((acc, product) => {
              if (PRODUCTS_LIST[value].includes(product.name)) {
                return [...acc, { value: product.id, label: product.displayName }];
              }
              return acc;
            }, []);
          }
          if (![PRODUCT_TYPES.digitize, PRODUCT_TYPES.photoArt].includes(value)) {
            this.productOptions = this.selectedProducts;
          }
          return null;
        }
        case 'digitizeOptions': {
          this.productOptions = this.productList
            .find(({ id }) => id === value)
            ?.options.map((item) => ({ value: item.id, label: item.displayName })) || [];
          return null;
        }
        case 'pageCollections': {
          this.clearOneProductCollectionsActions();
          this.selectedCollection = null;
          this.selectedPageCollections = this.productCollections.reduce((acc, collection) => {
            if (collection.pageKey === value) {
              return [...acc, { value: collection.id, label: collection.description }];
            }
            return acc;
          }, []);
          return null;
        }
        case 'productCollections': {
          this.selectedFrame = null;
          this.getOneProductCollectionsActions(value);
          return null;
        }
        case 'productFrame': {
          this.productOptions = this.currentProductCollection.products
            .find((item) => item.id === value).options
            .map((item) => {
              const label = `${item.displayName} ${item.frameSize.name} ${item.frameOrientation} ${item.frameColor.name}`;
              return { value: item.id, label };
            });
          return null;
        }
        default:
          return null;
      }
    },
    onDeleteArticleBanner(id) {
      this.deleteArticleBannerActions({
        id,
        articleId: this.currentArticle.id,
      });
    },
    async onEditArticleBanner(banner) {
      const {
        id: articleBannerId,
        title,
        type,
        description,
        link,
        imageUrl,
        articles,
        socialsNetwork,
        product,
        informationProductCollection,
        buttonText,
      } = banner;
      if (type === CUSTOM_ADS) {
        this.editableTitle = title;
        this.editableDescription = description;
        this.editableLink = link;
        this.editableButtonText = buttonText;
        this.editableImageFileListCustom = [imageUrl];
      }
      if (type === ARTICLE) {
        this.editableTitle = title;
        this.editableArticlesList = articles.map(({ id }) => id);
      }
      if (type === PRODUCT) {
        this.editableTitle = title;
        this.editableDescription = description;
        this.editableLink = link;
        this.editableButtonText = buttonText;
        this.editableImageFileListProduct = [imageUrl];
        this.selectedProductType = product.type;
        this.handleChangeOptions(product.type, 'productType');
        if (informationProductCollection && Object.keys(informationProductCollection).length) {
          this.handleChangeOptions(informationProductCollection.pageKey, 'pageCollections');
          this.selectedPage = informationProductCollection.pageKey;
          this.selectedCollection = informationProductCollection.id;
          this.selectedFrame = product.parentId;
          await this.getOneProductCollectionsActions(informationProductCollection.id);
          this.handleChangeOptions(product.parentId, 'productFrame');
        } else if (product.type === 'digitize') {
          this.selectedDigitizeOption = product.parentId;
          this.handleChangeOptions(product.parentId, 'digitizeOptions');
        }
        this.productId = product.id;
      }
      if (type === SOCIAL_NETWORK) {
        this.editableTitle = title;
        this.editableLink = link;
        this.socialsNetwork = socialsNetwork.map(({ id, ...rest }) => ({ ...rest }));
        this.socialsNetworkImageList = socialsNetwork.map(({ imageUrl: image }) => image);
      }
      this.activeKey = type;
      this.editableBannerId = articleBannerId;
      this.isShowEditorBanner = true;
    },
    setDefaultData() {
      this.socialsNetwork = [];
      this.socialsNetworkImageList = [];
      this.selectedCollectionOnPage = null;
      this.selectedCollection = null;
      this.selectedFrame = null;
      this.selectedProducts = [];
      this.selectedProductType = null;
      this.selectedPageCollections = [];
      this.productId = null;
      this.selectedPage = null;
      this.selectedDigitizeOption = null;
      this.productOptions = [];
      this.imageFileListCustom = [];
      this.imageFileListProduct = [];
      this.editableBannerId = null;
      this.editableTitle = '';
      this.editableDescription = '';
      this.editableLink = '';
      this.editableButtonText = '';
      this.editableArticlesList = [];
      this.editableImageFileListCustom = [];
      this.editableImageFileListProduct = [];
    },
    getCategoryBanners() {
      const currentData = (this.allBannerAds || [])[this.currentArticle.categoryId];
      const { banners } = currentData || {};
      return banners || [];
    },
    getBannerList(currentType) {
      const banners = this.getCategoryBanners();
      const arr = banners
        .filter(({ type }) => type === currentType)
        .map(({ title, id }) => ({ label: title, value: id }));

      return arr;
    },
    async preselectTemplate(value, type) {
      const banners = this.getCategoryBanners();
      const currentBanner = banners.find((item) => item.id === value);
      if (type === CUSTOM_ADS) {
        const {
          title,
          description,
          buttonText,
          link,
          imageUrl,
        } = currentBanner;
        this.editableTitle = title || '';
        this.editableDescription = description || '';
        this.editableLink = link || '';
        this.editableButtonText = buttonText || '';
        this.editableImageFileListCustom = [imageUrl];
      }
      if (type === ARTICLE) {
        const { title, articles } = currentBanner;
        this.editableTitle = title;
        this.editableArticlesList = articles.map(({ id }) => id);
      }
      if (type === PRODUCT) {
        const {
          product,
          title,
          description,
          link,
          buttonText,
          imageUrl,
          informationProductCollection,
        } = currentBanner;
        this.editableTitle = title;
        this.editableDescription = description;
        this.editableLink = link;
        this.editableButtonText = buttonText;
        this.editableImageFileListProduct = [imageUrl];
        this.selectedProductType = product.type;
        this.handleChangeOptions(product.type, 'productType');
        if (informationProductCollection && Object.keys(informationProductCollection).length) {
          this.handleChangeOptions(informationProductCollection.pageKey, 'pageCollections');
          this.selectedPage = informationProductCollection.pageKey;
          this.selectedCollection = informationProductCollection.id;
          this.selectedFrame = product.parentId;
          await this.getOneProductCollectionsActions(informationProductCollection.id);
          this.handleChangeOptions(product.parentId, 'productFrame');
        } else if (product.type === 'digitize') {
          this.selectedDigitizeOption = product.parentId;
          this.handleChangeOptions(product.parentId, 'digitizeOptions');
        }
        this.productId = product.id;
      }
      if (type === SOCIAL_NETWORK) {
        const {
          title,
          link,
          socialsNetwork,
        } = currentBanner;
        this.editableTitle = title;
        this.editableLink = link;
        this.socialsNetwork = socialsNetwork.map(({ id, ...rest }) => ({ ...rest }));
        this.socialsNetworkImageList = socialsNetwork.map(({ imageUrl: image }) => image);
      }
    },
  },
  computed: {
    ...mapState({
      articleBanner: (state) => state.blogs.articleBanner,
      isArticleBannerLoaded: (state) => state.blogs.isArticleBannerLoaded,
      isLoadingBlog: (state) => state.blogs.isLoading,
      articlesList: (state) => state.blogs.articlesList,
      productList: (state) => state.products.productList,
      productCollections: (state) => state.products.productCollections,
      currentProductCollection: (state) => state.products.currentProductCollection,
      isLoadingProduct: (state) => state.products.isLoading,
      isCurrentProductCollectionLoaded: (state) => state.products.isCurrentProductCollectionLoaded,
      currentArticle: (state) => state.blogs.currentArticle,
      allBannerAds: (state) => state.blogs.allBannerAds,
    }),
  },
  watch: {
    articleBanner(newValue) {
      if (newValue?.length > 0) {
        const products = this.articleBanner
          .filter((item) => item.type === PRODUCT)
          .map((item) => item.product);
        const productCollectionIds = products
          .filter((item) => item.productCollectionId)
          .map((item) => item.productCollectionId);
        if (productCollectionIds) {
          this.getAllProductCollectionsActions([...new Set(productCollectionIds)]);
        }
      }
    },
  },
  mounted() {
    this.getArticlesAction({ limit: 999999, offset: 0 });
    this.getProductsActions();
    this.getProductCollectionsActions();
    this.getCategoryBanners();
  },
};
</script>

<template>
  <div
    :class="b('')"
  >
    <div
      :class="b('tabs-banner-editor-wrapper')"
      v-if="isShowEditorBanner"
    >
      <a-tabs
        v-model:activeKey="activeKey"
        type="line"
        @change="setDefaultData"
      >
        <a-tab-pane
          :key="CUSTOM_ADS"
          tab="Author ads"
        >
          <a-select
            :class="b('template-selector')"
            placeholder="Templates"
            style="width: 200px"
            :options="this.getBannerList(CUSTOM_ADS)"
            @change="(value) => preselectTemplate(value, CUSTOM_ADS)"
          />
          <FormKit
            type="form"
            id="customBannerForm"
            @submit="onSubmit"
            :actions="false"
          >
            <div :class="b('row')">
              <div :class="b('form-inputs')">
                <FormKit
                  type="text"
                  name="title"
                  label="Title"
                  v-model="editableTitle"
                  placeholder="Enter title"
                  validation="required"
                  :classes="{
                    wrapper: b('input-form-wrapper'),
                  }"
                />
                <FormKit
                  type="text"
                  name="description"
                  label="Description"
                  v-model="editableDescription"
                  placeholder="Enter description"
                />
                <FormKit
                  type="text"
                  name="link"
                  label="Link"
                  v-model="editableLink"
                  placeholder="Enter link"
                />
                <FormKit
                  type="text"
                  name="buttonText"
                  label="Button text"
                  v-model="editableButtonText"
                  placeholder="Enter button text"
                />
              </div>
              <UploadImages
                v-model:files="imageFileListCustom"
                :isMultiple="false"
                :initial-images="editableImageFileListCustom"
                :withUpdateInitialImages="true"
                :classProps="b('uploader')"
              />
            </div>
            <div :class="b('form-buttons')">
              <a-button
                @click="setDefaultData"
                type="primary"
                danger
                ghost
              >
                Clear form
              </a-button>
              <a-button
                @click="() => onSubmitForm('customBannerForm')"
                type="primary"
              >
                {{ editableBannerId ? "Edit banner" :  "Create Banner" }}
              </a-button>
            </div>
          </FormKit>
        </a-tab-pane>
        <a-tab-pane
          :key="ARTICLE"
          tab="Article"
        >
          <a-select
            :class="b('template-selector')"
            placeholder="Templates"
            style="width: 200px"
            :options="this.getBannerList(ARTICLE)"
            @change="(value) => preselectTemplate(value, ARTICLE)"
          />
          <FormKit
            type="form"
            id="articleBannerForm"
            @submit="onSubmit"
            :actions="false"
          >
            <FormKit
              type="text"
              name="title"
              label="Title"
              v-model="editableTitle"
              placeholder="Enter title"
              validation="required"
              :classes="{
                wrapper: b('input-form-wrapper'),
              }"
            />
            <FormKit
              type="checkbox"
              name="articlesId"
              multiple
              label="Articles"
              :options="articlesList.map(item => ({
                label: item.title, value: item.id,
              }))"
              v-model="editableArticlesList"
              :classes="{
                options: b('input-form-options-checkbox'),
              }"
              validation="required|min:1"
            />
            <div :class="b('form-buttons')">
              <a-button
                @click="setDefaultData"
                type="primary"
                danger
                ghost
              >
                Clear form
              </a-button>
              <a-button
                @click="() => onSubmitForm('articleBannerForm')"
                type="primary"
              >
                {{ editableBannerId ? "Edit banner" :  "Create Banner" }}
              </a-button>
            </div>
          </FormKit>
        </a-tab-pane>
        <a-tab-pane
          :key="PRODUCT"
          tab="Product"
        >
          <a-select
            :class="b('template-selector')"
            placeholder="Templates"
            style="width: 200px"
            :options="this.getBannerList(PRODUCT)"
            @change="(value) => preselectTemplate(value, PRODUCT)"
          />
          <FormKit
            type="form"
            id="productBannerForm"
            @submit="onSubmit"
            :actions="false"
          >
            <div :class="b('row')">
              <div :class="b('column')">
                <a-select
                  v-model:value="selectedProductType"
                  placeholder="Select product type"
                  style="width: 200px"
                  :options="PRODUCT_TYPES_LIST"
                  @change="(value) => handleChangeOptions(value, 'productType')"
                />
                <a-select
                  v-if="selectedProductType === PRODUCT_TYPES.digitize
                    && selectedProducts && selectedProducts.length > 0"
                  placeholder="Select product"
                  v-model:value="selectedDigitizeOption"
                  style="width: 200px"
                  :options="selectedProducts"
                  @change="(value) => handleChangeOptions(value, 'digitizeOptions')"
                />
                <template
                  v-if="selectedProductType === PRODUCT_TYPES.photoArt"
                >
                  <a-select
                    placeholder="Select page"
                    style="width: 200px"
                    v-model:value="selectedPage"
                    :options="PRODUCT_PAGES"
                    @change="(value) => handleChangeOptions(value, 'pageCollections')"
                  />
                  <a-select
                    v-if="selectedPageCollections && selectedPageCollections.length > 0"
                    v-model:value="selectedCollection"
                    placeholder="Select collection"
                    style="width: 200px"
                    :options="selectedPageCollections"
                    @change="(value) => handleChangeOptions(value, 'productCollections')"
                  />
                  <a-select
                    v-if="
                      currentProductCollection
                      && currentProductCollection.id
                      && !isLoadingProduct
                    "
                    v-model:value="selectedFrame"
                    placeholder="Select frame"
                    style="width: 200px"
                    :options="getOptionListFrames()"
                    @change="(value) => handleChangeOptions(value, 'productFrame')"
                  />
                  <a-spin
                    v-else-if="
                    isLoadingProduct
                     && !isCurrentProductCollectionLoaded"
                    size="large"
                  ></a-spin>
                </template>
              </div>
              <div :class="b('form-inputs')">
                <FormKit
                  v-if="productOptions && productOptions.length"
                  type="select"
                  name="productId"
                  label="Product"
                  v-model="productId"
                  placeholder="Please select product"
                  :options="productOptions"
                  :classes="{
                    wrapper: b('input-form-wrapper'),
                  }"
                  validation="required"
                />
                <FormKit
                  type="text"
                  name="description"
                  label="Description"
                  v-model="editableDescription"
                  placeholder="Enter description"
                />
                <FormKit
                  type="text"
                  name="link"
                  label="Link"
                  v-model="editableLink"
                  placeholder="Enter link"
                />
                <FormKit
                  type="text"
                  name="title"
                  label="Per item"
                  v-model="editableTitle"
                  placeholder="Enter types item"
                  :classes="{
                    wrapper: b('input-form-wrapper'),
                  }"
                />
                <FormKit
                  type="text"
                  name="buttonText"
                  label="Button text"
                  v-model="editableButtonText"
                  placeholder="Enter button text"
                />
                <UploadImages
                  v-model:files="imageFileListProduct"
                  :isMultiple="false"
                  :initial-images="editableImageFileListProduct"
                  :withUpdateInitialImages="true"
                  :classProps="b('uploader')"
                />
              </div>
            </div>
            <div :class="b('form-buttons')">
              <a-button
                @click="setDefaultData"
                type="primary"
                danger
                ghost
              >
                Clear form
              </a-button>
              <a-button
                @click="() => onSubmitForm('productBannerForm')"
                type="primary"
              >
                {{ editableBannerId ? "Edit banner" :  "Create Banner" }}
              </a-button>
            </div>
          </FormKit>
        </a-tab-pane>
        <a-tab-pane
          :key="SOCIAL_NETWORK"
          tab="Social network"
        >
          <a-select
            :class="b('template-selector')"
            placeholder="Templates"
            style="width: 200px"
            :options="this.getBannerList(SOCIAL_NETWORK)"
            @change="(value) => preselectTemplate(value, SOCIAL_NETWORK)"
          />
          <div :class="b('social-network-tab-wrapper')">
            <FormKit
              type="form"
              id="socialNetworkList"
              @submit="addToSocialNetworkList"
              :actions="false"
              :classes="{
                outer: b('submit-form-btn'),
              }"
            >
              <div :class="b('social-editor-wrapper')">
                <div :class="b('row')">
                  <div :class="b('form-inputs')">
                    <FormKit
                      type="select"
                      name="typeSocialNetwork"
                      label="Social network"
                      placeholder="Please select type social network"
                      :options="SOCIAL_NETWORK_TYPE"
                      :classes="{
                        wrapper: b('input-form-wrapper'),
                      }"
                        validation="required"
                    />
                    <FormKit
                      type="text"
                      name="link"
                      label="Link"
                      placeholder="Enter link"
                      :classes="{
                        wrapper: b('input-form-wrapper'),
                      }"
                    />
                    <FormKit
                        type="text"
                        name="title"
                        label="Title for Social Media"
                        placeholder="Enter title for Social Media"
                        validation="required"
                        :classes="{
                      wrapper: b('input-form-wrapper'),
                    }"
                    />
                  </div>
                  <div :class="b('column')">
                    <UploadImages
                      v-model:files="socialsNetworkImageList"
                      :isMultiple="false"
                      :classProps="b('uploader')"
                    />
                    <FormKit
                      type="button"
                      @click="() => onSubmitForm('socialNetworkList')"
                      :classes="{
                        outer: b('submit-form-btn'),
                      }"
                    >
                      Add <PlusOutlined/>
                    </FormKit>
                  </div>
                </div>
              </div>
            </FormKit>
            <FormKit
              type="form"
              id="socialMediaBannerForm"
              :actions="false"
              @submit="onSubmit"
            >
              <h1>Banner social network</h1>
              <FormKit
                type="text"
                name="title"
                label="Title"
                placeholder="Enter title"
                v-model="editableTitle"
                validation="required"
                :classes="{
                  wrapper: b('input-form-wrapper'),
                }"
              />
              <div v-if="socialsNetwork.length">
                <h3>Social media list</h3>
                <div :class="b('social-media-list')">
                  <div
                    v-for="(item, index) in socialsNetwork"
                    :key="item.title + index"
                    :class="b('social-media')"
                  >
                    <span :class="b('social-media-description')">
                      {{ item.title }}
                    </span>
                      <span :class="b('social-media-description')">
                      {{ item.type }}
                    </span>
                    <span :class="b('social-media-description')">
                      {{ item.link }}
                    </span>
                    <a-button
                      type="primary"
                      danger
                      @click="onDeleteSocialNetwork(index)"
                    > <DeleteOutlined /></a-button>
                  </div>
                </div>
                <div :class="b('form-buttons')">
                  <a-button
                      @click="setDefaultData"
                      type="primary"
                      danger
                      ghost
                  >
                    Clear form
                  </a-button>
                  <a-button
                    @click="() => onSubmitForm('socialMediaBannerForm')"
                    type="primary"
                    ghost
                  >
                    {{ editableBannerId ? "Edit banner" :  "Create Banner" }}
                  </a-button>
                </div>
              </div>
              <h4
                v-else
                :class="b('social-warning')"
              >
                Add banner to the list Social Media
              </h4>
            </FormKit>
          </div>
        </a-tab-pane>
      </a-tabs>
      <a-button
        type="primary"
        danger
        :class="b('close-editor-wrapper')"
        shape="circle"
        size="small"
        @click="handleShowEditorBanner"
      >
        <CloseOutlined/>
      </a-button>
    </div>
    <a-spin
      v-if="!isArticleBannerLoaded && isLoadingBlog"
      size="large"
    />
    <div :class="b('banner-list')">
      <div
        :class="b('list-with-arrows')"
        v-if="!isShowEditorBanner"
      >
        <a-button
          type="primary"
          @click="handleShowEditorBanner"
          size="large"
        >
          Add banner<PlusOutlined/>
        </a-button>
      </div>
      <div
        v-for="(banner, index) in articleBanner"
        :key="banner.id"
        :class="b('list-with-arrows')"
      >
        <a-button
          v-if="index !== 0"
          type="primary"
          html-type="button"
          :class="b('change-order-button')"
          @click="editArticleBannerOrderActions({
            articleId: currentArticle.id,
            banners: [
              { id: banner.id, index: articleBanner[index - 1].index },
              { id: articleBanner[index - 1].id, index: banner.index }
            ],
          })"
        >
          <template #icon>
            <LeftOutlined />
          </template>
        </a-button>
        <div v-else :class="b('change-order-button')"/>
        <article-ads-card
          v-if="banner.type === ARTICLE"
          :card="banner"
          :onEdit="onEditArticleBanner"
          :onDelete="onDeleteArticleBanner"
        />
        <custom-ads-card
          v-if="banner.type === CUSTOM_ADS"
          :card="banner"
          :onEdit="onEditArticleBanner"
          :onDelete="onDeleteArticleBanner"
        />
        <social-ads-card
          v-if="banner.type === SOCIAL_NETWORK"
          :card="banner"
          :onEdit="onEditArticleBanner"
          :onDelete="onDeleteArticleBanner"
        />
        <product-ads-card
          v-if="banner.type === PRODUCT"
          :card="banner"
          :onEdit="onEditArticleBanner"
          :onDelete="onDeleteArticleBanner"
        />
        <a-button
          v-if="index !== (articleBanner.length - 1)"
          type="primary"
          html-type="button"
          :class="b('change-order-button')"
          @click="editArticleBannerOrderActions({
            articleId: currentArticle.id,
            banners:[
              { id: banner.id, index: articleBanner[index + 1].index },
              { id: articleBanner[index + 1].id, index: banner.index }
            ]
          })"
        >
          <template #icon>
            <RightOutlined />
          </template>
        </a-button>
        <div v-else :class="b('change-order-button')"/>
      </div>
    </div>
  </div>
</template>

<style src="./style.scss" lang="scss" />
